import { useState, useEffect } from 'react';
import moment from 'moment';
import { Typography } from '@mui/material';
import { getColor } from '@assets/theme';

export const LiveClock = ({ color }: { color?: string }) => {
  const [now, setNow] = useState(moment().format('LTS'));
  const { textColor } = getColor();
  useEffect(() => {
    const interval = setInterval(() => {
      setNow(moment().format('LTS'));
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  return (
    <Typography
      sx={{
        color: color ?? textColor,
        whiteSpace: 'nowrap',
        width: '80px',
        textAlign: 'center',
      }}
    >
      {now}
    </Typography>
  );
};
